import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';

export function SkuForm({ alert, onSubmit, values = {} }) {
  const { register, handleSubmit } = useForm();

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {alert ? alert : null}
      <Form.Group controlId="skuFormId">
        <Form.Label>Mã SKU</Form.Label>
        <Form.Control
          defaultValue={values.skuId}
          name="skuId"
          placeholder="Nhập Mã SKU"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group controlId="skuFormName">
        <Form.Label>Tên SKU</Form.Label>
        <Form.Control
          defaultValue={values.skuName}
          name="skuName"
          placeholder="Nhập Tên SKU"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group controlId="skuFormColor">
        <Form.Label>Màu Sắc</Form.Label>
        <Form.Control
          defaultValue={values.color}
          name="color"
          placeholder="Nhập Màu Sắc"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Form.Group controlId="skuFormPictures">
        <Form.Label>Hình Ảnh</Form.Label>
        <Form.Control
          as="textarea"
          defaultValue={values.skuPictures}
          name="skuPictures"
          placeholder="Mỗi hình 1 dòng"
          ref={register}
          rows="3"
        />
      </Form.Group>
      <Form.Group controlId="skuFormGuideLink">
        <Form.Label>Hướng Dẫn</Form.Label>
        <Form.Control
          defaultValue={values.guideLink}
          name="guideLink"
          placeholder="Nhập Link Hướng Dẫn"
          ref={register}
          type="text"
        />
      </Form.Group>
      <Button type="submit" variant="primary">
        Gửi
      </Button>
    </Form>
  );
}
